export const MEDIA_LIBRARY_FILES_PAGE_SIZE = 54;
